// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useEffect } from 'react';
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import TemplateContract from '../../../../utils/TemplateContract';
import { useMarketData } from '../../common/marketData/useMarketData';
import { usePositions } from '../../common/positions/usePositions';

export const useFulfilSettlementObligationForm = (
  collateralAgreement?: TemplateContract<CollateralAgreement>,
) => {
  // --- POSITIONS ---
  const {
    eligibleInstruments,
    positions,
    addPosition,
    updatePositionInstrument,
    updatePositionAmount,
    removePosition,
    resetPositions,
    updatePositionsWithNewAgreement,
  } = usePositions({ collateralAgreement });

  // --- MARKET DATA ---
  const { marketData, addPricingData, updatePricingData, removePricingData } =
    useMarketData(collateralAgreement);

  useEffect(() => {
    updatePositionsWithNewAgreement(collateralAgreement);
  }, [updatePositionsWithNewAgreement, collateralAgreement]);

  return {
    eligibleInstruments,

    positions,
    addPosition,
    updatePositionInstrument,
    updatePositionAmount,
    removePosition,
    resetPositions,

    marketData,
    addPricingData,
    updatePricingData,
    removePricingData,
  };
};
